import React from "react";


export default function Tag(props) {
  return (
    <p
      className={`ds-tag ${props.type} ${props.removable != undefined && 'removable'}`}
      onClick={() => props.removable && props.onRemove && props.onRemove()}
    >
      {props.label}
    </p>
  );
}


/*

Usage:

<Tag type="" label="" removable />

- type: primary / secondary / over-image
- label: String
- removable (Optional)

*/
